// extracted by mini-css-extract-plugin
module.exports = {"root":"VehicleCarousel_root__bd9I_","header":"VehicleCarousel_header__0DEwD"};